// src/pages/help/topics/abonnementPaiements.js
// Guide « Abonnement & Paiements ». Contenu validé — modifications ici.
export const fr = {
  title: "Abonnement & Paiements",
  tagline: "Formules, licence FMReplay, renouvellement et paiement",
  readMin: 5,
  intro:
    "L'abonnement FullMetrix permet d'accéder aux outils et fonctionnalités inclus dans la formule choisie. Il donne également droit à la licence d'utilisation de FMReplay. La gestion de l'abonnement se fait depuis le profil FullMargin, dans la partie Gestion des abonnements.",
  brief: [
    "Savoir ce que débloque l'abonnement, licence FMReplay comprise",
    "Gérer, renouveler ou résilier depuis le profil FullMargin",
    "Comprendre le renouvellement automatique selon le moyen de paiement",
  ],
  steps: [
    {
      title: "Choisir une formule",
      text: "Mensuelle, annuelle ou offre donnant accès à un niveau de fonctionnalités spécifique. Prix et conditions affichés dans Abonnement & Paiements.",
    },
    {
      title: "Payer",
      text: "Carte bancaire, paiement mobile, cryptomonnaie ou autre moyen disponible dans ton pays. La disponibilité varie selon la région.",
    },
    {
      title: "Gérer depuis FullMargin",
      text: "Profil FullMargin → Gestion des abonnements : formule active, période de validité, état, renouvellement, informations de paiement, résiliation.",
    },
    {
      title: "Surveiller le renouvellement",
      text: "Vérifie la validité du moyen de paiement, le solde disponible, la date de renouvellement et l'état de l'abonnement.",
    },
  ],
  tips: [
    "Les abonnements FullMetrix ne sont pas remboursables (politique de remboursement FullMargin, disponible en pied de page du site principal).",
    "Certains paiements mobiles ou en cryptomonnaie ne permettent pas le renouvellement automatique : renouvellement manuel à prévoir.",
    "Ne partage jamais publiquement les informations complètes de ta carte bancaire, ton mot de passe ou tes codes de sécurité.",
  ],
  faq: [
    {
      q: "À quoi donne accès l'abonnement FullMetrix ?",
      a:
        "L'abonnement FullMetrix permet d'accéder aux outils et fonctionnalités inclus dans la formule choisie.\n\n" +
        "Selon le type d'abonnement souscrit, l'utilisateur peut notamment accéder à :\n" +
        "• l'Agent IA MT5\n" +
        "• le Journal automatique\n" +
        "• l'Exécution des ordres\n" +
        "• le Copy Trading\n" +
        "• les Challenges\n" +
        "• le Strategy Hub\n" +
        "• l'Analyse fondamentale\n" +
        "• les outils de Graphiques & Backtest\n" +
        "• les autres fonctionnalités disponibles sur FullMetrix",
    },
    {
      q: "L'abonnement donne-t-il accès à FMReplay ?",
      a:
        "Oui.\n\n" +
        "Un abonnement FullMetrix actif donne également droit à une licence d'utilisation de FMReplay, disponible dans la partie Graphiques & Backtest.\n\n" +
        "Cette licence permet d'utiliser l'outil directement dans MetaTrader 5, conformément aux conditions de l'abonnement choisi.\n\n" +
        "Si l'abonnement expire ou devient inactif, l'accès à la licence et à certaines fonctionnalités peut être interrompu.",
    },
    {
      q: "Quels types d'abonnements sont disponibles ?",
      a:
        "FullMetrix peut proposer plusieurs formules, notamment :\n" +
        "• un abonnement mensuel\n" +
        "• un abonnement annuel\n" +
        "• différentes offres donnant accès à des niveaux de fonctionnalités spécifiques\n\n" +
        "Les outils accessibles dépendent donc de la formule sélectionnée par l'utilisateur.",
    },
    {
      q: "Comment gérer son abonnement ?",
      a:
        "L'utilisateur peut gérer son abonnement directement depuis son profil FullMargin.\n\n" +
        "Dans la partie Gestion des abonnements, il peut notamment :\n" +
        "• consulter la formule active\n" +
        "• vérifier la période de validité\n" +
        "• consulter l'état de l'abonnement\n" +
        "• renouveler son abonnement\n" +
        "• modifier certaines informations de paiement\n" +
        "• résilier l'abonnement lorsque cette option est disponible",
    },
    {
      q: "Comment résilier un abonnement ?",
      a:
        "La résiliation peut être effectuée depuis la partie Gestion des abonnements du profil FullMargin.\n\n" +
        "La résiliation empêche les prochains renouvellements automatiques, mais ne supprime pas nécessairement immédiatement l'accès déjà payé.\n\n" +
        "L'accès peut rester actif jusqu'à la fin de la période d'abonnement en cours, selon les conditions de la formule souscrite.",
    },
    {
      q: "Les abonnements FullMetrix sont-ils remboursables ?",
      a:
        "Non.\n\n" +
        "Les abonnements FullMetrix ne sont pas remboursables, conformément à la politique de remboursement de FullMargin.\n\n" +
        "Cette politique est disponible dans le pied de page du site principal FullMargin.\n\n" +
        "Il est recommandé de la consulter avant de confirmer un paiement ou un renouvellement.",
    },
    {
      q: "Quels moyens de paiement sont disponibles ?",
      a:
        "Selon les options proposées au moment du paiement, l'utilisateur peut payer notamment par :\n" +
        "• carte bancaire\n" +
        "• moyen de paiement mobile\n" +
        "• cryptomonnaie\n" +
        "• autres moyens disponibles dans son pays ou sur la plateforme de paiement\n\n" +
        "La disponibilité des moyens de paiement peut varier selon la région de l'utilisateur.",
    },
    {
      q: "L'abonnement est-il renouvelé automatiquement ?",
      a:
        "Cela dépend du moyen de paiement utilisé.\n\n" +
        "Certains moyens de paiement permettent le renouvellement automatique de l'abonnement afin d'éviter une interruption d'accès à FullMetrix.\n\n" +
        "D'autres moyens, notamment certains paiements mobiles ou en cryptomonnaie, peuvent nécessiter un renouvellement manuel.\n\n" +
        "Avant de payer, l'utilisateur doit vérifier si son moyen de paiement prend en charge le renouvellement automatique.",
    },
    {
      q: "Que se passe-t-il si le renouvellement échoue ?",
      a:
        "Si le renouvellement automatique ne peut pas être effectué :\n" +
        "• l'utilisateur peut recevoir une notification\n" +
        "• l'abonnement peut devenir inactif\n" +
        "• l'accès à certains outils peut être suspendu\n" +
        "• la licence FMReplay peut cesser de fonctionner\n" +
        "• l'utilisateur devra renouveler manuellement son abonnement\n\n" +
        "Il est donc recommandé de vérifier régulièrement :\n" +
        "• la validité du moyen de paiement\n" +
        "• le solde disponible\n" +
        "• la date de renouvellement\n" +
        "• l'état de l'abonnement dans FullMargin",
    },
    {
      q: "Comment contacter le support pour un problème de paiement ?",
      a:
        "Pour obtenir une réponse plus rapide, nous recommandons de contacter le support FullMargin par WhatsApp.\n\n" +
        "Il est conseillé d'envoyer :\n" +
        "• l'adresse e-mail du compte FullMargin\n" +
        "• la formule d'abonnement concernée\n" +
        "• la date du paiement\n" +
        "• le moyen de paiement utilisé\n" +
        "• la référence de la transaction\n" +
        "• une capture du paiement ou du message d'erreur\n\n" +
        "Ne partage jamais publiquement les informations complètes de ta carte bancaire, ton mot de passe ou tes codes de sécurité.",
    },
  ],
  related: ["graphiques-backtest", "autres", "faq-generale"],
};

export const en = {
  title: "Subscription & Payments",
  tagline: "Plans, FMReplay licence, renewal and payment",
  readMin: 5,
  intro:
    "The FullMetrix subscription unlocks the tools and features included in the chosen plan. It also grants the FMReplay usage licence. The subscription itself is managed from your FullMargin profile, in the Subscription management section.",
  brief: [
    "Know what the subscription unlocks, FMReplay licence included",
    "Manage, renew or cancel from your FullMargin profile",
    "Understand automatic renewal depending on the payment method",
  ],
  steps: [
    {
      title: "Choose a plan",
      text: "Monthly, annual, or an offer giving access to a specific feature level. Prices and conditions are shown in Subscription & Payments.",
    },
    {
      title: "Pay",
      text: "Bank card, mobile payment, cryptocurrency or another method available in your country. Availability varies by region.",
    },
    {
      title: "Manage from FullMargin",
      text: "FullMargin profile → Subscription management: active plan, validity period, status, renewal, payment details, cancellation.",
    },
    {
      title: "Watch the renewal",
      text: "Check the payment method validity, the available balance, the renewal date and the subscription status.",
    },
  ],
  tips: [
    "FullMetrix subscriptions are non-refundable (FullMargin refund policy, available in the main site footer).",
    "Some mobile or cryptocurrency payments do not support automatic renewal: plan for a manual renewal.",
    "Never share publicly your full card details, your password or your security codes.",
  ],
  faq: [
    {
      q: "What does the FullMetrix subscription unlock?",
      a:
        "The FullMetrix subscription unlocks the tools and features included in the chosen plan.\n\n" +
        "Depending on the plan, you can access:\n" +
        "• the MT5 AI Agent\n" +
        "• the Automatic journal\n" +
        "• Order execution\n" +
        "• Copy Trading\n" +
        "• Challenges\n" +
        "• the Strategy Hub\n" +
        "• Fundamental analysis\n" +
        "• the Charting & Backtest tools\n" +
        "• the other features available on FullMetrix",
    },
    {
      q: "Does the subscription include FMReplay?",
      a:
        "Yes.\n\n" +
        "An active FullMetrix subscription also grants an FMReplay usage licence, available in the Charting & Backtest section.\n\n" +
        "That licence lets you use the tool directly inside MetaTrader 5, under the conditions of the chosen plan.\n\n" +
        "If the subscription expires or becomes inactive, access to the licence and some features can be interrupted.",
    },
    {
      q: "What subscription types are available?",
      a:
        "FullMetrix can offer several plans, including:\n" +
        "• a monthly subscription\n" +
        "• an annual subscription\n" +
        "• different offers giving access to specific feature levels\n\n" +
        "The tools you can access therefore depend on the plan you selected.",
    },
    {
      q: "How do I manage my subscription?",
      a:
        "You can manage your subscription directly from your FullMargin profile.\n\n" +
        "In the Subscription management section you can:\n" +
        "• see the active plan\n" +
        "• check the validity period\n" +
        "• check the subscription status\n" +
        "• renew your subscription\n" +
        "• change some payment details\n" +
        "• cancel the subscription when that option is available",
    },
    {
      q: "How do I cancel a subscription?",
      a:
        "Cancellation is done from the Subscription management section of your FullMargin profile.\n\n" +
        "Cancelling stops future automatic renewals, but does not necessarily remove access you already paid for.\n\n" +
        "Access can remain active until the end of the current subscription period, depending on the plan conditions.",
    },
    {
      q: "Are FullMetrix subscriptions refundable?",
      a:
        "No.\n\n" +
        "FullMetrix subscriptions are non-refundable, in line with the FullMargin refund policy.\n\n" +
        "That policy is available in the footer of the main FullMargin site.\n\n" +
        "We recommend reading it before confirming a payment or a renewal.",
    },
    {
      q: "Which payment methods are available?",
      a:
        "Depending on the options offered at checkout, you can pay by:\n" +
        "• bank card\n" +
        "• mobile payment\n" +
        "• cryptocurrency\n" +
        "• other methods available in your country or on the payment platform\n\n" +
        "Payment method availability can vary by region.",
    },
    {
      q: "Is the subscription renewed automatically?",
      a:
        "It depends on the payment method used.\n\n" +
        "Some payment methods support automatic renewal so your FullMetrix access is not interrupted.\n\n" +
        "Others, in particular some mobile or cryptocurrency payments, may require a manual renewal.\n\n" +
        "Before paying, check whether your payment method supports automatic renewal.",
    },
    {
      q: "What happens if the renewal fails?",
      a:
        "If automatic renewal cannot go through:\n" +
        "• you may receive a notification\n" +
        "• the subscription can become inactive\n" +
        "• access to some tools can be suspended\n" +
        "• the FMReplay licence can stop working\n" +
        "• you will have to renew manually\n\n" +
        "We therefore recommend regularly checking:\n" +
        "• the validity of the payment method\n" +
        "• the available balance\n" +
        "• the renewal date\n" +
        "• the subscription status in FullMargin",
    },
    {
      q: "How do I contact support about a payment problem?",
      a:
        "For a faster answer, we recommend contacting FullMargin support on WhatsApp.\n\n" +
        "Please send:\n" +
        "• the email address of your FullMargin account\n" +
        "• the subscription plan involved\n" +
        "• the payment date\n" +
        "• the payment method used\n" +
        "• the transaction reference\n" +
        "• a screenshot of the payment or of the error message\n\n" +
        "Never share publicly your full card details, your password or your security codes.",
    },
  ],
  related: ["graphiques-backtest", "autres", "faq-generale"],
};
